import { Dispatch, SetStateAction } from 'react';

import { RiskLevelFilterType } from 'api/types/entity';
import { SelectFilter } from 'components/Filters/SelectFilter';
import { useTranslation } from 'libs/i18n';

interface Props {
  riskLevels: RiskLevelFilterType[];
  setRiskLevels: Dispatch<SetStateAction<RiskLevelFilterType[]>>;
}

export const RiskLevelFilter = ({ riskLevels, setRiskLevels }: Props) => {
  const { t } = useTranslation();

  const items = Object.values(RiskLevelFilterType).map((v) => ({
    label: t(`client.riskLevel.riskLevelType.${v}`),
    value: v,
  }));

  return (
    <SelectFilter
      activeValues={riskLevels}
      options={items}
      title={t('client.filters.riskLevel')}
      onChange={setRiskLevels}
    />
  );
};
